import { type ApolloError, gql, useQuery } from '@apollo/react-hooks';
import { type UserRole } from '../../../components';

export type SystemNotification = {
  effectiveFrom: Date;
  effectiveTo?: Date;
  userRoles: UserRole[];
  title: string;
  message: string;
  isHTML: boolean;
  hasRead: boolean;
};

type GetApplicantInformation = {
  systemNotifications: SystemNotification[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
};

export const useGetSystemNotification = (
  skip: boolean,
): GetApplicantInformation => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query {
        getNotifications {
          effectiveFrom
          effectiveTo
          userRoles
          title
          message
          isHTML
          hasRead
        }
      }
    `,
    {
      fetchPolicy: 'network-only',
      skip,
    },
  );

  const notifications = data?.getNotifications ?? [];

  const systemNotifications: SystemNotification[] = notifications?.map(
    (note: SystemNotification) => {
      return {
        effectiveFrom: note?.effectiveFrom,
        effectiveTo: note?.effectiveTo,
        userRoles: note?.userRoles ?? [],
        title: note?.title ?? '',
        message: note?.message ?? '',
        isHTML: note?.isHTML ?? false,
        hasRead: note?.hasRead ?? false,
      };
    },
  );

  return {
    systemNotifications,
    loading,
    error,
    refetch,
  };
};
